const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e`, `c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e`, 1, 33), undefined, true, false, 1));
            }

            getTemplateName() {
                return `c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e`;
            }

            getSourceContext() {
                return new this.Source(``, `c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e`, ``);
            }
        }],
        [33, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e`, 1);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, (context.has(`imgSrc`) ? context.get(`imgSrc`) : null)]]), false, false, 3));
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>`);
                this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, (((context.has(`text`))) ? (this.env.getFilter('default').traceableCallable(8, this.source)(...[(context.has(`text`) ? context.get(`text`) : null), `Hello world!`])) : (`Hello world!`)), `html`, null, true]));
                this.echo(`</p>
  `);
            }

            getTemplateName() {
                return `c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e');

let template = env.loadTemplate('c9006a951c4fb556e807479c5f0d2d1c1658ad88bee1fe470476d4a177b2119e');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/media/demo/image.twig", args: context }
     );
     return rendered;;
};